import { SERVER_URI } from '../Constant/server';
import { apiGet, apiPost, apiPut, apiPost1,apiPut1 } from '../utils/axios';

const ADD_RECEIPT = SERVER_URI + '/receipt';
const BIND_GET_RECEIPT = SERVER_URI + '/get-receipt';
const UPDATE_STATUS = SERVER_URI + '/change-receipt-status/';
const UPDATE_RECEIPT = SERVER_URI + '/receipt/';


export default {

  Create_Add_Receipt: async function (paylaod) {
    console.log('paylaod re',paylaod);
    return apiPost1(ADD_RECEIPT, paylaod)
  },
  GetReceipt: async function (paylaod) {
    return apiPost(BIND_GET_RECEIPT, paylaod)
  },
  UpdateStatus: async function (id) {
    return apiGet(UPDATE_STATUS + id)
  },
  updateReceipt: async function (id, payload) {
    return apiPut1(UPDATE_RECEIPT + id, payload)
  }
};